import React from 'react';

export default function Header({ abaAtiva, onChangeAba, dropdown }) {
  const abas = ['Geral', 'Equipes', 'Análise Individual', 'Rota'];
  
  return (
    <header style={{
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 24px',
      background: 'var(--surface)',
      borderBottom: '1px solid var(--border)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        <span style={{ fontSize: 'var(--font-lg)', fontWeight: 700, color: 'var(--amber)' }}>
          Imobluz
        </span>
        <nav style={{ display: 'flex', gap: '4px' }}>
          {abas.map((aba) => (
            <button
              key={aba}
              onClick={() => onChangeAba(aba)}
              style={{
                padding: '6px 16px',
                background: abaAtiva === aba ? 'rgba(245,158,11,0.15)' : 'transparent',
                border: 'none',
                borderRadius: 'var(--radius-sm)',
                color: abaAtiva === aba ? 'var(--amber)' : 'var(--muted)',
                fontSize: 'var(--font-base)',
                fontWeight: abaAtiva === aba ? 600 : 400,
                cursor: 'pointer',
                fontFamily: 'var(--font-family)',
                transition: 'all var(--transition-fast)',
              }}
            >
              {aba}
            </button>
          ))}
        </nav>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {dropdown}
      </div>
    </header>
  );
}